import { MOCK_CATALOG } from "@/mocks/data/catalog";
import type { LabResultWire } from "@/mocks/types";

const CERTIFICATE_URL = "/mocks/certificates/certificate-of-analysis.svg";

export const MOCK_LAB_RESULTS: LabResultWire[] = [
  MOCK_CATALOG.DAILY_BALANCE,
  MOCK_CATALOG.QUICK_EASE,
  MOCK_CATALOG.NIGHT_REST,
  MOCK_CATALOG.MORNING_FOCUS,
  MOCK_CATALOG.CALM_DAY,
].map((product, index) => {
  return {
    id: index + 1,
    name: `${product.name} - Sample Batch ${String(index + 1).padStart(3, "0")}`,
    certificate_url: CERTIFICATE_URL,
  };
});
